/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

 /*!
 * EventEmitter v5.2.9 - git.io/ee
 * Oliver Caldwell - https://oli.me.uk/
 */
!function(e){"use strict";function t(){}function n(e,t){for(var n=e.length;n--;)if(e[n].listener===t)return n;return-1}function r(e){return function(){return this[e].apply(this,arguments)}}function i(e){return"function"==typeof e||e instanceof RegExp||!(!e||"object"!=typeof e)&&i(e.listener)}var s=t.prototype,o=e.EventEmitter;s.getListeners=function(e){var t,n,r=this._getEvents();if(e instanceof RegExp){t={};for(n in r)r.hasOwnProperty(n)&&e.test(n)&&(t[n]=r[n])}else t=r[e]||(r[e]=[]);return t},s.flattenListeners=function(e){var t,n=[];for(t=0;t<e.length;t+=1)n.push(e[t].listener);return n},s.getListenersAsObject=function(e){var t,n=this.getListeners(e);return n instanceof Array&&(t={},t[e]=n),t||n},s.addListener=function(e,t){if(!i(t))throw new TypeError("listener must be a function");var r,s=this.getListenersAsObject(e),o="object"==typeof t;for(r in s)s.hasOwnProperty(r)&&-1===n(s[r],t)&&s[r].push(o?t:{listener:t,once:!1});return this},s.on=r("addListener"),s.addOnceListener=function(e,t){return this.addListener(e,{listener:t,once:!0})},s.once=r("addOnceListener"),s.defineEvent=function(e){return this.getListeners(e),this},s.defineEvents=function(e){for(var t=0;t<e.length;t+=1)this.defineEvent(e[t]);return this},s.removeListener=function(e,t){var r,i,s=this.getListenersAsObject(e);for(i in s)s.hasOwnProperty(i)&&-1!==(r=n(s[i],t))&&s[i].splice(r,1);return this},s.off=r("removeListener"),s.addListeners=function(e,t){return this.manipulateListeners(!1,e,t)},s.removeListeners=function(e,t){return this.manipulateListeners(!0,e,t)},s.manipulateListeners=function(e,t,n){var r,i,s=e?this.removeListener:this.addListener,o=e?this.removeListeners:this.addListeners;if("object"!=typeof t||t instanceof RegExp)for(r=n.length;r--;)s.call(this,t,n[r]);else for(r in t)t.hasOwnProperty(r)&&(i=t[r])&&("function"==typeof i?s.call(this,r,i):o.call(this,r,i));return this},s.removeEvent=function(e){var t,n=typeof e,r=this._getEvents();if("string"===n)delete r[e];else if(e instanceof RegExp)for(t in r)r.hasOwnProperty(t)&&e.test(t)&&delete r[t];else delete this._events;return this},s.removeAllListeners=r("removeEvent"),s.emitEvent=function(e,t){var n,r,i,s,o=this.getListenersAsObject(e);for(s in o)if(o.hasOwnProperty(s))for(n=o[s].slice(0),i=0;i<n.length;i++)r=n[i],!0===r.once&&this.removeListener(e,r.listener),r.listener.apply(this,t||[])===this._getOnceReturnValue()&&this.removeListener(e,r.listener);return this},s.trigger=r("emitEvent"),s.emit=function(e){var t=Array.prototype.slice.call(arguments,1);return this.emitEvent(e,t)},s.setOnceReturnValue=function(e){return this._onceReturnValue=e,this},s._getOnceReturnValue=function(){return!this.hasOwnProperty("_onceReturnValue")||this._onceReturnValue},s._getEvents=function(){return this._events||(this._events={})},t.noConflict=function(){return e.EventEmitter=o,t},"function"==typeof define&&define.amd?define(function(){return t}):"object"==typeof module&&module.exports?module.exports=t:e.EventEmitter=t}("undefined"!=typeof window?window:this||{});

/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 */
!function(e){var n;if("function"==typeof define&&define.amd&&(define(e),n=!0),"object"==typeof exports&&(module.exports=e(),n=!0),!n){var t=window.Cookies,o=window.Cookies=e();o.noConflict=function(){return window.Cookies=t,o}}}(function(){function f(){for(var e=0,n={};e<arguments.length;e++){var t=arguments[e];for(var o in t)n[o]=t[o]}return n}function a(e){return e.replace(/(%[0-9A-Z]{2})+/g,decodeURIComponent)}return function e(u){function c(){}function t(e,n,t){if("undefined"!=typeof document){"number"==typeof(t=f({path:"/"},c.defaults,t)).expires&&(t.expires=new Date(1*new Date+864e5*t.expires)),t.expires=t.expires?t.expires.toUTCString():"";try{var o=JSON.stringify(n);/^[\{\[]/.test(o)&&(n=o)}catch(e){}n=u.write?u.write(n,e):encodeURIComponent(String(n)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,decodeURIComponent),e=encodeURIComponent(String(e)).replace(/%(23|24|26|2B|5E|60|7C)/g,decodeURIComponent).replace(/[\(\)]/g,escape);var r="";for(var i in t)t[i]&&(r+="; "+i,!0!==t[i]&&(r+="="+t[i].split(";")[0]));return document.cookie=e+"="+n+r}}function n(e,n){if("undefined"!=typeof document){for(var t={},o=document.cookie?document.cookie.split("; "):[],r=0;r<o.length;r++){var i=o[r].split("="),c=i.slice(1).join("=");n||'"'!==c.charAt(0)||(c=c.slice(1,-1));try{var f=a(i[0]);if(c=(u.read||u)(c,f)||a(c),n)try{c=JSON.parse(c)}catch(e){}if(t[f]=c,e===f)break}catch(e){}}return e?t[e]:t}}return c.set=t,c.get=function(e){return n(e,!1)},c.getJSON=function(e){return n(e,!0)},c.remove=function(e,n){t(e,"",f(n,{expires:-1}))},c.defaults={},c.withConverter=e,c}(function(){})});

var GlobalEvents = new EventEmitter();

$(document).ready(function(){
  $( ".content_switch" ).click(function() {
    $( ".short_desc" ).hide();
    $( ".full_desc" ).show();
  });
  $('p.space_fix').filter(function () {
    return this.innerHTML
    .replace("&nbsp;"," ")
    .trim()
    == ""
  }).remove();
});

(function() {
  var elem = document.querySelector('.store-carousel-1');
  if(elem !== null) {
    var flkty = new Flickity( elem, {
      // options
    });
  }

  var elem = document.querySelector('.store-carousel-2');
  if(elem !== null) {
    var flkty = new Flickity( elem, {
      // options
    });
  }

})();



if (document.getElementById('countdownTimer')) {
  pad = function(n, len) { // leading 0's
    var s = n.toString();
    return (new Array( (len - s.length + 1) ).join('0')) + s;
  };

  function checkForExcludedDate(dateToCheck, date) {
    date = date.setHours(0,0,0,0)
    return dateToCheck.toString() === new Date(date).toString() ? true : false;
  } 

  function changeTomorrowDate(tomorrow) {
    var tomDay = tomorrow.getDay();
    if(tomDay === 0 || tomDay === 6) {
      if(tomDay === 0) {
        tomorrow.setDate(tomorrow.getDate() + 1);
        
      } else if(tomDay === 6) {
        tomorrow.setDate(tomorrow.getDate() + 2);
      } 
    }
    return tomorrow;
  }

  var timerRunning = setInterval(
    function countDown() {
      var now = new Date();
      const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
      const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      const exclusionsString = "";
      const exclusions = exclusionsString.split(',');
      if ( (now.getDay() >= 1) && (now.getDay() <= 5) ) { // Mon - Fri
        var target = 15; // 15:00hrs is the cut-off point
        if (now.getHours() < target) { // don't do anything if we're past the cut-off point
          var hrs = (target - 1) - now.getHours();
          if (hrs < 0) hrs = 0;
          var mins = 59 - now.getMinutes();
          if (mins < 0) mins = 0;
          var secs = 59 - now.getSeconds();
          if (secs < 0) secs = 0;
          var tomorrow = new Date();
          tomorrow.setDate(now.getDate() +1);
          var isExcluded = false;
          var daysToAdd = 1;
          tomorrow = changeTomorrowDate(tomorrow);
          exclusions.forEach(function(value) {
            var dateToCheck = new Date(value);
            isExcluded = checkForExcludedDate(dateToCheck, tomorrow);
            if(isExcluded) {
              tomorrow.setDate(tomorrow.getDate() + daysToAdd);
              tomorrow = changeTomorrowDate(tomorrow);
            }
          });
          var nextDate = days[tomorrow.getDay()] + " " + tomorrow.getDate() + " " + months[tomorrow.getMonth()];
          var str = "<span class='promo_product_head'>Order in " + '<strong>' + pad(hrs, 2) + "h " + pad(mins, 2) + "m " + pad(secs, 2) + 's</strong>' + " to receive by <strong>" + nextDate + "</strong></span>";
          document.getElementById('countdownTimer').innerHTML = str;
        }
        //console.log(target);
        if (now.getHours() >= target) {
          document.getElementById('countdownTimer').innerHTML = "<span class='promo_product_head'>Order now and we'll ship next working day</span>";
        }
      }
      else {
        document.getElementById('countdownTimer').innerHTML = "<span class='promo_product_head'>Order now and we'll ship Monday</span>";
      }
    }, 1000
  );
}

//<span class='highlighted_time'>Free Royal Mail Tracked &gt; £149</span>



//cookies
function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i=0; i<ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0)==' ') c = c.substring(1);
    if(c.indexOf(name) == 0)
      return c.substring(name.length,c.length);
  }
  return "";
}


// // let's show and hide the stock app
// $(document).ready(function(){
//   document.addEventListener('variant:changed', function(event) {
//     var variant = event.detail.variant; // Gives you access to the whole variant details
//     if (variant.available) {
//       $(".iStock-wrapper").css("display", "none");
//       $(".ProductForm__new_button_wrap").css("display", "block");

//     } else {
//       $(".iStock-wrapper").css("display", "block");
//       $(".ProductForm__new_button_wrap").css("display", "none");
//     }
//   });
// });

// Cuber Slideshow

(function() {

  window.checkVisible = function(elm, horizontal) {
    if ( horizontal ) {
      var rect = elm.getBoundingClientRect();
      var viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
      return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
    } else {
      var rect = elm.getBoundingClientRect();
      var viewWidth = Math.max(document.documentElement.clientWidth, window.innerWidth);
      return !(rect.right < 0 || rect.left - viewWidth >= 0);
    }
  };

  window.debounce = function(func, wait, immediate) {
    var timeout;
    return function() {
      var context = this, args = arguments;
      var later = function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  };

  window.returnClipPathWithPrefix = function() {
    var testEl = document.createElement('testelement');
    testEl.style['clip-path'] = 'inset(0 0 0 0)';
    if ( testEl.style['clip-path'] !== '' ) {
      return 'clip-path';
    } else {
      testEl.style['-webkit-clip-path'] = 'inset(0 0 0 0)';
      if ( testEl.style['-webkit-clip-path'] !== '' ) {
        return '-webkit-clip-path';
      } else {
        return 'clip-path';
      }
    }
  };

  $.fn.KrownSplitScreenSlider = function() {

    var $SplitScreenSlider = $(this);

    var pluginObj = {

      id: $SplitScreenSlider.attr('id'),

      _screenHeight: 0,

      _scrollEnabled: true,

      _headerHeight: 0,

      _currentScroll: 0,

      _scrollMedia: function($currentSlide, $previousSlide, $currentSlideMedia, $previousSlideOverlay, scrollValue) {

        $currentSlideMedia.css('height', scrollValue );

        if ( $previousSlideOverlay ) {
          $previousSlideOverlay.css('opacity', ( Math.ceil(scrollValue * 50 / pluginObj._screenHeight ) ) / 100 );
        }

        var scrollFactor = Math.round(pluginObj._screenHeight / 6);

        $previousSlide.find('.caption').css('transform', 'translateY(' + ( 0 - Math.ceil(scrollValue * ( scrollFactor*1 ) / pluginObj._screenHeight ) ) + 'px)');
        $previousSlide.find('.title').css('transform', 'translateY(' + ( 0 - Math.ceil(scrollValue * ( scrollFactor*0.75 ) / pluginObj._screenHeight ) ) + 'px)');
        $previousSlide.find('.subtitle').css('transform', 'translateY(' + ( 0 - Math.ceil(scrollValue * ( scrollFactor*0.5 ) / pluginObj._screenHeight ) ) + 'px)');
        $previousSlide.find('.button').css('transform', 'translateY(' + ( 0 - Math.ceil(scrollValue * ( scrollFactor*0.25 ) / pluginObj._screenHeight ) ) + 'px)');

        $currentSlide.find('.caption').css('transform', 'translateY(' + ( Math.ceil(scrollValue * ( scrollFactor * 1) / pluginObj._screenHeight) - ( scrollFactor * 1) ) + 'px)');
        $currentSlide.find('.title').css('transform', 'translateY(' + ( Math.ceil(scrollValue * ( scrollFactor * 0.75) / pluginObj._screenHeight) - ( scrollFactor * 0.75) ) + 'px)');
        $currentSlide.find('.subtitle').css('transform', 'translateY(' + ( Math.ceil(scrollValue * ( scrollFactor * 0.5) / pluginObj._screenHeight) - ( scrollFactor * 0.5) ) + 'px)');
        $currentSlide.find('.button').css('transform', 'translateY(' + ( Math.ceil(scrollValue * ( scrollFactor * 0.25) / pluginObj._screenHeight) - ( scrollFactor * 0.25) ) + 'px)');

      },

      mount: function( flick, $section ){

        var clipPath = window.returnClipPathWithPrefix();

        var $slider = $section.find('.box__slideshow-split'),
            $slides = $slider.find('.slideshow-item'),
            $slidesMedia = $slider.find('.site-box-background-container').children('div'),
            slidesBlackArray = [];

        pluginObj._currentScroll = $(window).scrollTop();

        // mobile slider

        if ( $section.index() > 0 ) {
          pluginObj._headerHeight = $('#section-header').outerHeight();
        }

        pluginObj._scrollEnabled = true;

        pluginObj._screenHeight = navigator.userAgent.match(/ipad/i) ? window.screen.availHeight : $(window).height();

        if ( window.matchMedia('(max-width: 768px)').matches ) {
          $slider.css('height', 'auto');
          $slider.addClass('remove-min-height');
          $slides.height($(window).height() - $('#section-header').outerHeight(true));
          pluginObj._scrollEnabled = false;
        } else {
          $slider.css('height', 'auto');
          $slider.removeClass('remove-min-height');
          $slides.css('height', 'auto');
        }

        // split

        $slides.each(function(key, elm){
          if ( key == 0 || $(window).scrollTop() >= $(elm).offset().top ) {
            $slidesMedia.eq(key).css('height', '100%');
          } else {
            $slidesMedia.eq(key).css('height', '0');
          }
          if ( $(elm).find('.lazyload').length > 0 ) {
            lazySizes.loader.unveil($(elm).find('.lazyload')[0]);
          }
        });

        $slidesMedia.each(function(key){

          $(this).addClass('active');

          if ( $(this).find('.site-box-black-overlay').length <= 0 ) {
            $(this).append('<span class="site-box-black-overlay" />');
          }
          slidesBlackArray.push($(this).find('.site-box-black-overlay'));

        });

        var previous = -1,
            currentOld = -1;

        $(window).on('scroll.split-slider-' + pluginObj.id, function(){

          var scrollTop = $(window).scrollTop() >= 0 ? $(window).scrollTop() : 0;
          //scrollTop -= pluginObj._headerHeight;
          var sliderTop = $slider.offset().top;

          if ( pluginObj._scrollEnabled ) {

            var current = 0;

            if ( scrollTop + pluginObj._headerHeight - pluginObj._headerHeight < $slider.offset().top && ! $slider.hasClass('back-to-normal') ) {
              $slider.addClass('back-to-normal');
            }

            $slides.each(function(key, $elm){
              if ( window.checkVisible($elm, true) ) {
                current = key;
              }
            });

            if ( current != currentOld ) {
              if ( pluginObj._currentScroll < scrollTop && currentOld > 0 ) {
                pluginObj._scrollMedia( $slides.eq(currentOld), $slides.eq(previous), $slidesMedia.eq(currentOld), slidesBlackArray[previous], pluginObj._screenHeight);
              } else if ( pluginObj._currentScroll > $(window).scrollTop() && currentOld > 0 ) {
                pluginObj._scrollMedia( $slides.eq(currentOld), $slides.eq(previous), $slidesMedia.eq(currentOld), slidesBlackArray[previous], 0);
              }
              currentOld = current;
              previous = current-1;
            }

            if ( current > 0 ) {

              var scrollValue = ( scrollTop - sliderTop ) - pluginObj._screenHeight * ( current - 1 );

              if ( ! $slider.hasClass('back-to-normal') ) {
                pluginObj._scrollMedia( $slides.eq(current), $slides.eq(previous), $slidesMedia.eq(current), slidesBlackArray[previous], scrollValue);

              }
              if ( scrollTop + pluginObj._screenHeight >= sliderTop + $slider.height() && ! $slider.hasClass('back-to-normal') ) {
                $slider.addClass('back-to-normal');
              } else if ( scrollTop + pluginObj._screenHeight < sliderTop + $slider.height() && $slider.hasClass('back-to-normal' ) ) {
                $slider.removeClass('back-to-normal');
              }

            }

          }

          pluginObj._currentScroll = scrollTop;

        });

      }

    };

    $(window).on('resize.split-slider', window.debounce(function(){
      $(window).off('scroll.splid-slider-' + pluginObj.id);
      pluginObj.mount(false, $SplitScreenSlider);
    }, 250));

    pluginObj.mount( true, $SplitScreenSlider );

  };

  window.CUBER = {
    SplitSlider: {
      mount: function( $section ) {
        if ( ! $section.find('.box__slideshow-split').hasClass('one-image') ) {
          $section.KrownSplitScreenSlider();
        } else {
          $(window).on('resize.split-screen-single', function(){
            $section.find('.box__slideshow-split').height($(window).height() - $('#section-header').outerHeight(true)).addClass('remove-min-height');
          }).trigger('resize.split-screen-single');
        }
      }
    },
    Main: {
      $siteBoxes: null,
      _animateEverything: function(firstAnimation) {

        var i = 0;

        this.$siteBoxes.each(function(){

          var vp = 0;
          if ( ! $(this).hasClass('active') && $(window).scrollTop() + $(window).height() > $(this).offset().top + vp ) {

            i++;

            setTimeout((function(){
              $(this).addClass('active');
            }).bind(this), ( 100 * i ) );

          }

        });
      },
      mount: function() {
        this.$siteBoxes = $('.site-box:not(.footer-box)');

        this._animateEverything(true);

        $(window).on('scroll.fade-animation', (function(e){
          this._animateEverything(false);
        }).bind(this));
      }
    }
  }

  window.CUBER.Main.mount();

  if ( $('.mount-slideshow').length > 0 ) {
    $('.mount-slideshow').each(function(){
      if ( $(this).find('.box__slideshow-split').length > 0 ) {
        window.CUBER.SplitSlider.mount($(this));
      }
    })
  }

})();

// Cuber blog

(function() {

  var blog_items = document.querySelectorAll('[data-cuber-blog-item]');
  var blog_titles = document.querySelectorAll('[data-cuber-blog-title]');

  if (!blog_items.length) {
    return;
  }

  cuber_blog_titles();

  window.addEventListener('scroll', cuber_blog_titles);

  function cuber_blog_titles() {
    var blog_items_top = blog_items[0].getBoundingClientRect().top;

    if (blog_items_top > 0) {
      blog_titles.forEach(function(blog_title) {
        blog_title.classList.remove('is-active');
      });

      blog_titles[0].classList.add('is-active');

      return;
    }

    var viewport_height = document.documentElement.clientHeight;

    blog_items.forEach(function(blog_item) {
      var blog_item_options = JSON.parse(blog_item.getAttribute('data-cuber-blog-item'));
      var blog_item_index = blog_item_options.index;

      var blog_item_top = blog_item.getBoundingClientRect().top;

      var blog_item_is_middle = (
        blog_item_top > (viewport_height / 2.5) &&
        blog_item_top < (viewport_height / 1.5)
      );

      var blog_title = document.querySelector('[data-cuber-blog-title=\'{ "index": ' + blog_item_index + ' }\']');

      if (blog_item_is_middle) {
        blog_title.classList.add('is-active');
      } else {
        blog_title.classList.remove('is-active');
      }
    });
  };

})();

// Cookies modal

(function() {

  function Self(element, events, options, module) {
    if( !Cookies.get('cookiesmodal') ) {
      show();
    } else {
      set_rakuten_consent();
    }

    events
      .on('cookiesmodalcta:click', function() {
        hide();
        Cookies.set('cookiesmodal', true);
        set_rakuten_consent();
      })
      .on('cookiesmodalclose:click', hide);

    function show() {
      document.documentElement.classList.add('is-active-cookies-modal');
    };

    function hide() {
      document.documentElement.classList.remove('is-active-cookies-modal');
    };

    function set_rakuten_consent() {
      window.__rmcp = [1, 2, 3, 4, 5];
      window.__rmuspc = 'YN';
    };
  };

  function Cta(element, events, options, module) {
    element.addEventListener('click', function() {
      events.trigger('cookiesmodalcta:click');
    });
  };

  function Close(element, events, options, module) {
    element.addEventListener('click', function() {
      events.trigger('cookiesmodalclose:click');
    });
  };

  function CookiesModal(element, options) {
    var defaults = {};

    options = Object.assign({}, defaults, options);

    var events = new EventEmitter();

    var refs = {
      self: [element],
      cta:  element.querySelectorAll('[data-ref-cta]'),
      close:  element.querySelectorAll('[data-ref-close]')
    };

    var module = {
      element: element,
      options: options,
      refs: refs
    };

    refs.self.forEach(function(element) {
      var options = module.options;

      Self(element, events, options, module);
    });

    refs.cta.forEach(function(element) {
      var options = element.getAttribute('data-ref-cta');
          options = JSON.parse(options || '{}');

      Cta(element, events, options, module);
    });

    refs.close.forEach(function(element) {
      var options = element.getAttribute('data-ref-close');
          options = JSON.parse(options || '{}');

      Close(element, events, options, module);
    });
  };

  var elements = document.querySelectorAll('[data-module-cookies-modal]');

  elements.forEach(function(element) {
    var options = element.getAttribute('data-module-cookies-modal');
        options = JSON.parse(options || '{}');

    CookiesModal(element, options);
  });

})();

// Fix Flickity bug

(function() {

  window.addEventListener('scroll', throttle(function() {
    trigger_resize();
  }));

  setTimeout(trigger_resize, 1000);

  function throttle(fn, threshhold, scope) {
    threshhold || (threshhold = 100);

    var last = null;
    var deferTimer = null;

    return function () {
      var context = scope || this;
      var now = +new Date;
      var args = arguments;

      if ( last && now < last + threshhold ) {
        clearTimeout(deferTimer);
        deferTimer = setTimeout(function () {
          last = now;
          fn.apply(context, args);
        }, threshhold);
      } else {
        last = now;
        fn.apply(context, args);
      }
    };
  };

  function trigger_resize() {
    var event = document.createEvent('HTMLEvents');
    event.initEvent('resize', true, false);
    document.dispatchEvent(event);
  };

})();

// Rakuten cart attribute

(function() {

  var is_rakuten_url = window.location.search.includes('ranMID');

  if (is_rakuten_url) {
    set_cart_attribute();
  }

  function set_cart_attribute() {
    var url = '/cart/update.js';

    var body = {
      attributes: {
        source: 'rakuten'
      }
    };

    fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    });
  };

})();

// Geolocation

(function() {

  geoip2.country(function(geolocation) {
    Cookies.set('geolocation', geolocation);
    GlobalEvents.trigger('geolocation', [geolocation]);
  });

})();

// Redirect popup

(function() {

  function Self(element, events, options, module) {
    var cookie_key = 'redirect-popup:' + options.country_iso_code;

    if (Cookies.get(cookie_key)) {
      return;
    }

    GlobalEvents.on('geolocation', function(geolocation) {
      // Hardcode country code for testing
      // geolocation.country.iso_code = 'DE';

      if (geolocation.country.iso_code != options.country_iso_code) {
        return;
      }

      element.classList.add('is-active');
    });

    events.on('close:click', function() {
      element.classList.remove('is-active');
      Cookies.set(cookie_key, true);
    });
  };

  function Close(element, events, options, module) {
    element.addEventListener('click', function() {
      events.trigger('close:click');
    });
  };

  function RedirectPopup(element, options) {
    var defaults = {};

    options = Object.assign({}, defaults, options);

    var events = new EventEmitter();

    var refs = {
      self: [element],
      close:  element.querySelectorAll('[data-ref-close]')
    };

    var module = {
      element: element,
      options: options,
      refs: refs
    };

    refs.self.forEach(function(element) {
      var options = module.options;

      Self(element, events, options, module);
    });

    refs.close.forEach(function(element) {
      var options = element.getAttribute('data-ref-close');
          options = JSON.parse(options || '{}');

      Close(element, events, options, module);
    });
  };

  var elements = document.querySelectorAll('[data-module-redirect-popup]');

  elements.forEach(function(element) {
    var options = element.getAttribute('data-module-redirect-popup');
        options = JSON.parse(options || '{}');

    RedirectPopup(element, options);
  });

})();

// Form submit on change

(function() {

  function Self(element, events, options, module) {
    Array.from(element.elements).forEach(function(form_element) {
      form_element.addEventListener('change', function() {
        element.submit();
      });
    });
  };

  function FormSubmitOnChange(element, options) {
    var defaults = {};

    options = Object.assign({}, defaults, options);

    var events = new EventEmitter();

    var refs = {
      self: [element]
    };

    var module = {
      element: element,
      options: options,
      refs: refs
    };

    refs.self.forEach(function(element) {
      var options = module.options;

      Self(element, events, options, module);
    });
  };

  var elements = document.querySelectorAll('[data-module-form-submit-on-change]');

  elements.forEach(function(element) {
    var options = element.getAttribute('data-module-form-submit-on-change');
        options = JSON.parse(options || '{}');

    FormSubmitOnChange(element, options);
  });

})();

// Hide products with tag from non-EU countries

(function() {

  // Spoof location for testing
  var spoof_location_us = {"continent":{"code":"NA","geoname_id":6255149,"names":{"zh-CN":"???","de":"Nordamerika","en":"North America","es":"Norteamirica","fr":"Amirique du Nord","ja":"?????","pt-BR":"Amirica do Norte","ru":"???????? ???????"}},"country":{"iso_code":"US","geoname_id":6252001,"names":{"zh-CN":"??","de":"USA","en":"United States","es":"Estados Unidos","fr":"Itats-Unis","ja":"???????","pt-BR":"Estados Unidos","ru":"???"}},"registered_country":{"iso_code":"US","geoname_id":6252001,"names":{"en":"United States","es":"Estados Unidos","fr":"Itats-Unis","ja":"???????","pt-BR":"Estados Unidos","ru":"???","zh-CN":"??","de":"USA"}},"traits":{"ip_address":"67.219.150.42","network":"67.219.144.0/20"},"represented_country":{"names":{}}};

  var spoof_location_au = {"continent":{"code":"OC","geoname_id":6255151,"names":{"ja":"?????","pt-BR":"Oceania","ru":"???????","zh-CN":"???","de":"Ozeanien","en":"Oceania","es":"Oceanma","fr":"Ocianie"}},"country":{"iso_code":"AU","geoname_id":2077456,"names":{"ja":"???????","pt-BR":"Australia","ru":"?????????","zh-CN":"????","de":"Australien","en":"Australia","es":"Australia","fr":"Australie"}},"registered_country":{"iso_code":"AU","geoname_id":2077456,"names":{"zh-CN":"????","de":"Australien","en":"Australia","es":"Australia","fr":"Australie","ja":"???????","pt-BR":"Australia","ru":"?????????"}},"traits":{"ip_address":"115.178.23.100","network":"115.178.16.0/21"},"represented_country":{"names":{}}};

  // Set to `false` in production
  var spoof_location = false;

  GlobalEvents.on('geolocation', init);

  window.addEventListener('collection:load-more:success', init);

  $(document).on('Searchanise.ResultsUpdated', init_searchanise_results);

  $(document).on('Searchanise.AutocompleteUpdated', init_searchanise_autocomplete);

  function init() {
    var geolocation = Cookies.getJSON('geolocation');

    if (!geolocation) {
      return;
    }

    if (spoof_location) {
      geolocation = spoof_location;
    }

    console.log('GEOLOCATION:');
    console.log(JSON.stringify(geolocation, null, 2));

    var excluded_product_tags = get_excluded_product_tags(geolocation);

    if (!excluded_product_tags.length) {
      return;
    }

    hide_excluded_product_items(excluded_product_tags);

    product_template_redirect(excluded_product_tags);
  };

  function hide_excluded_product_items(excluded_product_tags) {
    var product_item_elements = Array.from(document.querySelectorAll('[data-module-product-item]'))
      .filter(function(element) {
        var element_options = element.getAttribute('data-module-product-item');
            element_options = JSON.parse(element_options);

        var element_excluded = is_product_excluded(excluded_product_tags, element_options.tags);

        return element_excluded;
      });

    product_item_elements.forEach(function(product_item_element) {
      var grid_cell_element = product_item_element.closest('.Grid__Cell');

      if (grid_cell_element) {
        grid_cell_element.remove();
      }

      product_item_element.remove();
    });
  };

  function product_template_redirect(excluded_product_tags) {
    if (!window.location.href.includes('/products/')) {
      return;
    }

    var product_json_element = document.querySelector('[data-product-json]');

    // Exit if no product JSON found
    if (!product_json_element) {
      return;
    }

    var product_json = JSON.parse(product_json_element.innerHTML);

    // Redirect to homepage if excluded tag found
    var product_excluded = is_product_excluded(excluded_product_tags, product_json.product.tags);

    if (product_excluded) {
      window.location = '/';
    }
  };

  function init_searchanise_results(event, element) {
    hide_searchanise_excluded_product_items(element);
  };

  function init_searchanise_autocomplete(event, input_element, element) {
    hide_searchanise_excluded_product_items(element);
  };

  function hide_searchanise_excluded_product_items(element) {
    var geolocation = Cookies.getJSON('geolocation');

    if (!geolocation) {
      return;
    }

    if (spoof_location) {
      geolocation = spoof_location;
    }

    var excluded_product_tags = get_excluded_product_tags(geolocation);

    if (!excluded_product_tags.length) {
      return;
    }

    var elements = Array.from(element[0].querySelectorAll('.snize-product'))
      .filter(function(element) {
        return excluded_product_tags.some(function(tag) {
          return element.innerHTML.includes(tag);
        });
      });

    elements.forEach(function(element) {
      element.remove();
    });
  };

  function is_product_excluded(excluded_product_tags, product_tags) {
    if (!product_tags) {
      return false;
    }

    return product_tags.some(function(tag) {
      return excluded_product_tags.includes(tag);
    });
  };

  function get_excluded_product_tags(geolocation) {
    var excluded_product_tags = [];

    if (geolocation.continent.code != 'EU') {
      excluded_product_tags.push('EXCLUDE-NON-EU');

      if (geolocation.country.iso_code != 'US') {
        excluded_product_tags.push('EXCLUDE-NON-USA');
      }
    }

    return excluded_product_tags;
  };

})();

// Newsletter Modal

(function() {

var button_element = document.querySelector('[aria-controls="modal-newsletter"]');

if (!button_element) {
  return;
}

if (Cookies.get('newsletter-popup')) {
  return;
}

button_element.click();

Cookies.set('newsletter-popup', true);

})();

(function() {
  document.addEventListener('DOMContentLoaded', function() {
    var announcementScroll = document.querySelector('.AnnouncementBar__Content--scroll');
    this.initialConfig = Object.assign(JSON.parse(announcementScroll.getAttribute('data-flickity-config')));
    console.log('initial config', this.initialConfig);
    if (announcementScroll.children.length > 1) {
      var announceFlick = new Flickity(announcementScroll, this.initialConfig);

      // Set initial position to be 0
      announceFlick.x = 0;

      // Start the marquee animation
      play();

      // Main function that 'plays' the marquee.
      function play() {
        announceFlick.x = announceFlick.x - 0.15;
        announceFlick.settle(announceFlick.x);
        requestId = window.requestAnimationFrame(play);
      }

      // Main function to cancel the animation.
      function pause() {
        if (requestId) {
          window.cancelAnimationFrame(requestId)
          requestId = undefined;
        }
      }

      // Pause on mouse over / focusin
      announcementScroll.addEventListener('mouseover', pause, false);
      announcementScroll.addEventListener('focusin', pause, false);

      // Unpause on mouse out / focusout
      announcementScroll.addEventListener('mouseout', play, false);
      announcementScroll.addEventListener('focusout', play, false);

    }
  });
})();

class ComplementaryProducts extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.complimentaryUrl)
        .then(response => response.json())
        .then(res => {
          if(res.products.length) {
            console.log('res complimentary: ', res);
            document.querySelector('.also_title').style.display = 'block';
            res.products.forEach(product => {
              const template = document.querySelector('#also_template').content.cloneNode(true).children[0];
              const img = document.createElement('img');
              template.querySelector('[data-complementary-url]').href = product.url;
              template.querySelector('[data-complementary-url]').title = product.title;
              img.src = product.featured_image.replace('.jpg', '_400x400.jpg').replace('.png', '_400x400.png');
              img.alt = product.title;
              img.classList.add('main-prod-img');
              template.querySelector('[data-complementary-image]').appendChild(img);
              this.appendChild(template);
            })
          } else {
            document.querySelectorAll('.also_metafields_wrapper').length ? document.querySelector('.also_title').style.display = 'block' : '';
            document.querySelectorAll('.also_metafields_wrapper').length ? document.querySelectorAll('.also_metafields_wrapper')[0].style.display = 'block' : '';
          }
        })
        .catch(e => {
          console.error(e);
          document.querySelector('.also_wrapper').style.display = 'none';
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
  }
}

customElements.define('complementary-products', ComplementaryProducts);

class RelatedProducts extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.relatedUrl)
        .then(response => response.json())
        .then(res => {
          if(res.products.length) {
            console.log('res related: ', res);
            document.querySelector('.related_title').style.display = 'block';
            res.products.forEach(product => {
              const template = document.querySelector('#also_template').content.cloneNode(true).children[0];
              const img = document.createElement('img');
              template.querySelector('[data-complementary-url]').href = product.url;
              template.querySelector('[data-complementary-url]').title = product.title;
              img.src = product.featured_image.replace('.jpg', '_400x400.jpg').replace('.png', '_400x400.png');
              img.alt = product.title;
              img.classList.add('main-prod-img');
              template.querySelector('[data-complementary-image]').appendChild(img);
              this.appendChild(template);
            })
          }
        })
        .catch(e => {
          console.error(e);
          document.querySelector('.also_wrapper').style.display = 'none';
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
  }
}

customElements.define('related-products', RelatedProducts);

// (function() {
//   document.addEventListener('DOMContentLoaded', function() {
//     if(window.innerWidth > 1190) {
//       window.newGallery = {
//         init: function() {
//           const self = this;
//           self.delegateRoot = new domDelegate.Delegate(document.body);
//           self._initPhotoSwipe = self._initPhotoSwipe.bind(self);
//           var items = [];
//           var imageElements = document.querySelectorAll('.GalleryImage');

//           imageElements.forEach(function (item) {
//             if (item.classList.contains('GalleryImage--image')) {
//               items.push(item.querySelector('img'));
//             }
//             item.addEventListener('click', function(e) {
//               var selectedImageIndex = parseInt(e.currentTarget.getAttribute('data-image-media-position'));
//               self._initPhotoSwipe(items, selectedImageIndex);
//             })
//           });
//         },
//         _initPhotoSwipe: function(items, selectedImageIndex) {
          
//           var photoswipeContainer = document.querySelector('.pswp');

//           this.photoSwipeInstance = new PhotoSwipe(photoswipeContainer, false, items, {
//             index: selectedImageIndex,
//             showHideOpacity: true,
//             showAnimationDuration: 500,
//             loop: false,
//             history: false,
//             closeOnVerticalDrag: false,
//             allowPanToNext: false,
//             pinchToClose: false,
//             errorMsg: '<p class="pswp__error-msg">' + window.languages.productImageLoadingError + '</p>',
//             scaleMode: 'zoom',
//             getDoubleTapZoom: function getDoubleTapZoom(isMouseClick, item) {
//               if (isMouseClick) {
//                 return 1.6;
//               } else {
//                 return item.initialZoomLevel < 0.7 ? 1 : 1.33;
//               }
//             }
//           });

//           // this.photoSwipeInstance.listen('beforeChange', this._onSlideChanged.bind(this));
//           // this.photoSwipeInstance.listen('destroy', this._destroyPhotoSwipe.bind(this));
//           // this.photoSwipeInstance.listen('doubleTap', this._onDoubleTap.bind(this));
//           // this.photoSwipeInstance.listen('initialZoomIn', this._onInitialZoomIn.bind(this));
//           // this.photoSwipeInstance.listen('initialZoomOut', this._onInitialZoomOut.bind(this));

//           // this.delegateRoot.on('pswpTap', '.pswp__scroll-wrap', this._onSingleTap.bind(this));
//           this.delegateRoot.on('pswpTap', '.pswp__button--close', this.photoSwipeInstance.close);
//           this.delegateRoot.on('pswpTap', '.pswp__button--prev', this.photoSwipeInstance.prev);
//           this.delegateRoot.on('pswpTap', '.pswp__button--next', this.photoSwipeInstance.next);

//           this.photoSwipeInstance.init();
//         }
//       }
//       newGallery.init();
//     }
//   })
// })();

(function () {
  function getClosest(elem, selector) {
    // Element.matches() polyfill
    if (!Element.prototype.matches) {
        Element.prototype.matches =
            Element.prototype.matchesSelector ||
            Element.prototype.mozMatchesSelector ||
            Element.prototype.msMatchesSelector ||
            Element.prototype.oMatchesSelector ||
            Element.prototype.webkitMatchesSelector ||
            function(s) {
                var matches = (this.document || this.ownerDocument).querySelectorAll(s),
                    i = matches.length;
                while (--i >= 0 && matches.item(i) !== this) {}
                return i > -1;
            };
    }
    // Get the closest matching element
    for ( ; elem && elem !== document; elem = elem.parentNode ) {
      if ( elem.matches( selector ) ) return elem;
    }
    return null;
  };

  function toggleReadMore(e) {
    const parentElem = getClosest(e.currentTarget, '.SectionHeader__Description');
    const readMore = parentElem.querySelector('.readMore');
    const readLess = parentElem.querySelector('.readLess');
    if (readMore.classList.contains('open')) {
      readMore.classList.remove('open');
      readLess.classList.remove('open');
    } else {
      readMore.classList.add('open');
      readLess.classList.add('open');
    }
  }
  const readMoreLink = document.querySelectorAll('[data-read-more]');
  const readLessLink = document.querySelectorAll('[data-read-less]');
  if (!readMoreLink) return;
  readMoreLink.forEach(function (elem) {
    elem.addEventListener('click', toggleReadMore)
  });
  if (!readLessLink) return;
  readLessLink.forEach(function (elem) {
    elem.addEventListener('click', toggleReadMore)
  })
})();

document.addEventListener('variant:changed', function(event) {
  var variant = event.detail.variant; // Gives you access to the whole variant details
  if (!variant.available) {
    // setTimeout(() => $('.klaviyo-bis-trigger')[0].click(), 10);
    $('.klaviyo-bis-trigger').show();
  } else {
    $('.klaviyo-bis-trigger').hide();
  }
});